export default __webpack_public_path__ + "c7453bc42441bedfd8fc8eb09f875ab1.png";